import { render, staticRenderFns } from "./IndirectCost.vue?vue&type=template&id=2d35d486&scoped=true"
import script from "./IndirectCost.vue?vue&type=script&lang=js"
export * from "./IndirectCost.vue?vue&type=script&lang=js"
import style0 from "./IndirectCost.vue?vue&type=style&index=0&id=2d35d486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d35d486",
  null
  
)

export default component.exports